<template>
  <div class="grid-tile">
    <img
      alt="image thumbnail"
      height="150"
      class="grid-thumb"
      :src="media.signed_thumb_url"
    />
    <div class="grid-label">
      {{ media.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    media: Object,
  },
  name: "MediaMiniTile",
  beforeMount() {},
};
</script>

<style scoped>
.grid-tile {
  border: 1px solid var(--isim-light-icon);
  border-radius: 4px;
  margin: 8px;
}

.grid-thumb {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  width: 180px;
}

.grid-label {
  font-size: 12px;
  font-weight: 700;
  color: #014a8f;
  padding: 8px;
}
</style>
